export const BREAKPOINTS = {
    TABLET: 1200,
    MOBILE: 768
};
